import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';

import { getPriceInCurrency, formatPrice } from 'utils';
import { CURRENCIES } from '../../../constants';

import {
  Bike
} from 'utils/shapes';

import './order-price.css';

class OrderPrice extends PureComponent {
  renderPrice = price => {
    const { t, bikeIsReloading, currency } = this.props;

    const {
      symbol
    } = CURRENCIES.find(c => c.value === currency) || {}

    return bikeIsReloading ? '\u2014' : t('{{symbol}}\u00A0{{price}}', {
      symbol,
      price: formatPrice(price)
    });
  }
  render() {
    const { t, bike } = this.props;

    const price = getPriceInCurrency(bike.salesPrice, this.props.currency);
    const deposit = getPriceInCurrency(bike.deposit, this.props.currency);

    // TODO: button mobile icon
    return (
      <div className="order-price">
        <div className="price-info">
          <div className="price-item">
            <b>{t('Total price')}:</b>
            <span className="price-total">{this.renderPrice(price)}</span>
            <p>{t('All taxes and fees included')}</p>
          </div>
          <div className="price-item">
            <b>{t('Pay now')}:</b>
            <span className="price-now">{this.renderPrice(deposit)}</span>

            <p>{t('Best price guaranteed!')}</p>
          </div>
          <div className="price-item">
            <b>{t('Pay later on arrival')}:</b>
            <span className="price-later">{this.renderPrice(price - deposit)}</span>

            <p>{t('Final price')}</p>
            <p>{t('without unpleasant surprises')}</p>
          </div>
        </div>
      </div>
    );
  }
}

OrderPrice.propTypes = {
  currency: PropTypes.string.isRequired,
  bike: Bike.isRequired,
  bikeIsReloading: PropTypes.bool.isRequired,
  t: PropTypes.func.isRequired
};

export default translate(['detail_price'])(OrderPrice);



// WEBPACK FOOTER //
// ./src/widgets/Order/OrderPrice/index.js